<h2 class="sr-only">{{ "RechteId" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="rechteId" #form="ngForm">
  <cap-form-row column-classes="col-md-1,col-md-1">
    <cap-form-control column-classes="col-md-2,col-md-6" invalidKey="EingabeGrundbuchamtErforderlich" labelKey="Grundbuchamt">
      <cap-gb-amt
        (ngModelChange)="rechteId && (rechteId.grundbuchamtId = $event)"
        [hasfocus]="true"
        [ngModel]="rechteId && rechteId.grundbuchamtId"
        [nurGueltige]="false"
        [searchMode]="gbAmtSearchMode"
        class="typeahead-holder"
        name="grundbuchamtId"></cap-gb-amt>
      <button (click)="emptyAmtSearch()" class="btn btn-white" tabindex="-1" type="button">
        <span class="fas fa-times"></span>
      </button>
    </cap-form-control>
    <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="Jahr">
      <input
        (ngModelChange)="rechteId && (rechteId.rechteIdJahr = $event)"
        [ngModel]="rechteId && rechteId.rechteIdJahr"
        #rechteIdJahr
        name="rechteIdJahr"
        type="text" />
    </cap-form-control>
    <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Nummer">
      <input
        (ngModelChange)="rechteId && (rechteId.rechteIdNummer = $event)"
        [ngModel]="rechteId && rechteId.rechteIdNummer"
        name="rechteIdNummer"
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <div class="row mt-4">
    <div class="col-3">
      <cap-rechte-selection
        (ngModelChange)="rechteId && (rechteId.rechteSelection = $event)"
        [ngModel]="rechteId && rechteId.rechteSelection"
        name="rechteSelection"></cap-rechte-selection>
    </div>
    <div class="col-3">
      <cap-history-options
        (ngModelChange)="rechteId && (rechteId.historySearchOptions = $event)"
        [ngModel]="rechteId && rechteId.historySearchOptions"
        name="historySearchOptions"></cap-history-options>
    </div>
  </div>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
